<template>
    <section class="q10__page my-14">
        <div class="container px-11 2xl:px-3 m-auto">
            <div class="q10__article_container__title_head m-4">
                <!-- article title tour -->
                <article-title-tour
                        :options="{
                        tourtitle: currentPage.content.oTitleTour_tourtitle.text,
                        titlecolor: 'text-selective_yellow',
                        toursubtitle: currentPage.content.oTitleTour_toursubtitle.text,
                        subtitlecolor: 'text-nandor',
                    }"
                ></article-title-tour>
            </div>
            <div class="container-components">
                <div class="relative  break-inside-avoid text-center mx-auto ">
                    <image-with-descriptions
                            :options="{
                          image: 'pages/' +
                        currentPage.slug + '/' +
                        currentPage.images.image1.src,
                        position: 'pr-44',
                        }"
                    />
                    <div class="flex justify-center">
                        <TimelineTitle
                                :options="{
                            content:
                                currentPage.images.image1.edf,
                            position: '-ml-10',

                            fontSize: {
                                content: 'text-md md:text-xl lg:text-base',
                            },
                            color: {
                                content: 'text-nandor',
                            },


                        }"
                        >
                        </TimelineTitle>
                        <span
                            class="q10__copyright"
                            v-html="currentPage.content.oCard2_sOuterText.text"
                        ></span>
                    </div>

                </div>
                <div class="card break-inside-avoid">
                    <hotspot-richmedia :options="{
                        icon: 'diaporama',
                        collection : getRichmediaByCollection(currentPage, 'Création du CIH, témoignage de C. Perrier' ),
                    }" class="-top-0 -right-2 md:-right-4 lg:-right-2"/>

                    <TimelineTitle
                            
                            :options="{
                            year: currentPage.content.oCard2_sYear.text,
                            toptitle: currentPage.content.oCard2_sTopTitle.text,
                            pretitle: currentPage.content.oCard2_sPreTitle.text,
                            title: currentPage.content.oCard2_sTitle.text,
                            content: currentPage.content.oCard2_sText.text,

                            color: {
                                year: 'text-selective_orange',
                                pretitle: 'text-selective_yellow',
                                title: 'text-selective_yellow',
                                content: 'text-nandor',
                            },
                            fontSize: {
                                year: 'text-md md:text-lg lg:text-xl',
                                toptitle: 'text-md md:text-xl lg:text-2xl',
                                pretitle: 'text-2xl md:text-2xl lg:text-4xl',
                                title: 'text-4xl md:text-3xl lg:text-7xl',
                                content: 'text-md md:text-xl lg:text-base',
                                outerText: 'text-md',
                            },
                        }"
                    >
                    </TimelineTitle>
                </div>

                <div class="card  break-inside-avoid">

                    <div class="flex flex-col">
                        <div class="w-full">
                            <TimelineTitle

                                    :options="{
                                    year: currentPage.content.oCard3_sYear.text,
                                    pretitle:
                                        currentPage.content.oCard3_sTopTitle.text,
                                    title: currentPage.content.oCard3_sTitle.text,
                                    subtitle:
                                        currentPage.content.oCard3_sSubTitle.text,
                                    content:
                                        currentPage.content.oCard3.text,
                                    outerText:
                                        currentPage.content.oCard3_sOuterText,
                                    color: {
                                        year: 'text-selective_orange',
                                        title: 'text-selective_yellow',
                                        subtitle: 'text-selective_yellow',
                                        content: 'text-nandor',
                                    },
                                    fontSize: {
                                        year: 'text-md md:text-lg lg:text-xl',
                                        pretitle:
                                            'text-2xl md:text-2xl lg:text-3xl',
                                        title: 'text-3xl md:text-3xl lg:text-5xl xl:text-4xl',
                                        subtitle:
                                            'text-2xl md:text-2xl lg:text-3xl',
                                        content:
                                            'text-md md:text-xl lg:text-base',
                                    },
                                }"
                            >
                            </TimelineTitle>
                        </div>

                        <div class="w-2/3 lg:mx-auto lg:w-2/5">
                            <image-with-descriptions
                                    :options="{
                                   image: 'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image2.src,
                                }"
                            />
                        </div>
                    </div>
                </div>

                <!--    container-timeline-title-si-image-with-description        -->
                <div class="card break-inside-avoid"
                >
                    <!-- <hotspot-richmedia :options="{
                        icon: 'diaporama',
                        collection : getRichmediaByCollection(currentPage, 'Reconnaissance de l\'ADN environnement du CIH' ),
                    }" class="-top-0 -right-2"/> -->

                    <div
                            class="
                                container-timeline-title-si-image-with-description
                                relative
                                w-full
                            "
                    >
                        <div class="relative top-0 left-0 w-full lg:mx-auto">
                            <image-with-descriptions
                                    :options="{
                                        image: 'pages/' +
                                        currentPage.slug + '/' +
                                        currentPage.images.image3.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.image3.edf,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                                fontSize: 'text-sm md:text-base',
                                            },
                                        ],
                                    }"
                            />

                        <div class="custom_padding_top absolute top-0 left-0 p-5">
                            <TimelineTitle
                                    :options="{
                                        year: currentPage.content.oCard4_sYear.text,
                                        pretitle:
                                            currentPage.content.oCard4_sPreTitle.text,
                                        title: currentPage.content.oCard4_s1Title.text,
                                        subtitle:
                                            currentPage.content.oCard4_sSubTitle.text,

                                        fontSize: {
                                            year: 'text-md md:text-lg lg:text-xl',
                                            pretitle: 'text-xl 2xl:text-xl',
                                            title: 'text-4xl 2xl:text-6xl',
                                            subtitle: 'text-xl 2xl:text-xl',
                                            content:
                                                'text-md md:text-xl lg:text-base',
                                        },
                                        color: {
                                            year: 'text-selective_yellow',
                                            pretitle: 'text-white',
                                            title: 'text-white',
                                            subtitle: 'text-white',
                                            content: 'text-white',
                                        },
                                    }"
                            >
                            </TimelineTitle>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                            :options="{
                            content: currentPage.content.oCard4_sText.text,

                            fontSize: {},
                            color: {
                                year: 'text-selective_yellow',
                                pretitle: 'text-white',
                                title: 'text-nandor',
                                content: 'text-nandor',
                            },
                            position: {
                                bgContent: 'pt-0'
                            }
                        }"
                    >
                    </TimelineTitle>
                    <div class="flex justify-center">
                        <div
                                class="
                                rounded-circle
                                flex
                                justify-center
                                items-center
                                text-start
                                w-full
                                md:w-3/4
                                lg:w-full
                                rounded-full
                                bg-selective_yellow
                                p-20
                                mt-5
                            "
                        >
                            <TimelineTitle
                                    :options="{
                                    toptitle:
                                        currentPage.content.oCard4_s2TopTitle.text,
                                    pretitle:
                                        currentPage.content.oCard4_s2PreTitle.text,
                                    title: currentPage.content.oCard4_s2Title.text,
                                    year: currentPage.content.oCard4_sYear.text,

                                    fontSize: {
                                        year: 'text-md md:text-xl lg:text-xl',
                                        toptitle:
                                            'text-2xl md:text-2xl lg:text-2xl',
                                        pretitle:
                                            'text-2xl md:text-5xl lg:text-5xl',
                                        title: 'text-6xl md:text-6xl lg:text-6xl',
                                        subtitle:
                                            'text-xl md:text-2xl lg:text-2xl',
                                        content:
                                            'text-md md:text-xl lg:text-base',
                                    },
                                    color: {
                                        year: 'text-red-500',
                                        toptitle: 'text-white',
                                        pretitle: 'text-white',
                                        title: 'text-white',
                                        content: 'text-white',
                                    },
                                }"
                            >
                            </TimelineTitle>
                        </div>
                    </div>
                </div>
                <!--    container-timeline-title-si-image-with-description        -->
                <div
                        class="
                        container-timeline-title-si-image-with-description-second-1
                        relative
                        card  break-inside-avoid
                    "
                >
                    <hotspot-richmedia :options="{
                        icon: 'diaporama',
                        collection : getRichmediaByCollection(currentPage, 'Évolution de l’organisation du CIH en 2003' ), 
                    }" class="-top-0 -right-2"/>


                    <div class="relative mx-auto lg:w-full lg:h-full xl:w-full xl:h-full">
                        <image-with-descriptions
                                :options="{
                                image: 'pages/' +
                                currentPage.slug + '/' +
                                currentPage.images.image4.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image4.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-sm md:text-base',
                                    },
                                ],
                            }"
                        />

                    <div class="absolute top-0 right-0 bottom-0 left-0 m-auto mt-8 sm:mt-0 xl:mt-0 2xl:mt-0 p-2 lg:pt-20 xl:p-2 xl:pt-7 2xl:p-4 2xl:pt-14">
                        <TimelineTitle
                                :options="{
                                year: currentPage.content.oCard5_sYear.text,
                                pretitle: currentPage.content.oCard5_sPreTitle.text,
                                title: currentPage.content.oCard5_sTitle.text,
                                subtitle: currentPage.content.oCard5_sSubTitle.text,
                                content: currentPage.content.oCard5_sText.text,

                                fontSize: {
                                    pretitle: 'text-sm md:text-xl lg:text-xl xl:text-lg 2xl:text-2xl',
                                    year: 'text-base md:text-lg lg:text-md xl:text-lg 2xl:text-xl',
                                    title: 'text-2xl md:text-3xl lg:text-5xl xl:text-4xl 2xl:text-8xl',
                                    subtitle:
                                        'text-base md:text-xl lg:text-2xl xl:text-2xl 2xl:text-4xl',
                                    content: 'text-xs md:text-sm lg:text-lg xl:text-md 2xl:text-lg',
                                },
                                color: {
                                    year: 'text-red-500',
                                    pretitle: 'text-white',
                                    title: 'text-white',
                                    subtitle: 'text-white',
                                    content: 'text-white',
                                },
                            }"
                        >
                        </TimelineTitle>
                    </div>
                  </div>
                </div>

                <!--    container-timeline-title-si-image-with-description        -->
                <div
                        class="
                        container-timeline-title-si-image-with-description-second-2
                        card  break-inside-avoid
                    "
                >
                    <div class="relative w-full h-full">
                        <image-with-descriptions
                                :options="{
                                image500: 'pages/' +
                                currentPage.slug + '/' +
                                currentPage.images.image5.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image5.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-base',
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="absolute top-0 left-0 p-10">
                        <TimelineTitle
                                :options="{
                                year: currentPage.content.oCard6_sYear.text,
                                pretitle: currentPage.content.oCard6_sPreTitle.text,
                                title: currentPage.content.oCard6_sTitle.text,
                                content: currentPage.content.oCard6_sText.text,

                                fontSize: {
                                    year: 'text-md md:text-lg lg:text-xl',
                                    pretitle:
                                        'text-2xl md:text-2xl lg:text-3xl',
                                    title: 'text-4xl md:text-3xl lg:text-7xl',
                                    content: 'text-md md:text-xl lg:text-base',
                                },
                                color: {
                                    year: 'text-selective_yellow',
                                    pretitle: 'text-white',
                                    title: 'text-white',
                                    content: 'text-white',
                                },
                            }"
                        >
                        </TimelineTitle>
                    </div>
                </div>

                <!--    container-timeline-title-si-image-with-description        -->
                <div class="card  break-inside-avoid">

                    <hotspot-richmedia :options="{
                        icon: 'diaporama',
                        collection : getRichmediaByCollection(currentPage, 'Première université de printemps 2003' ),
                    }" class="-top-0 -right-2"/>


                    <div
                            class="
                            container-timeline-title-si-image-with-description-second-3
                            relativ
                            flex flex-col                         "
                    >


                        <TimelineTitle
                                :options="{
                                    year: currentPage.content.oCard7_sYear.text,
                                    title: currentPage.content.oCard7_sTitle.text,
                                    precontent:
                                        currentPage.content.oCard7_sMainText.text,
                                    content: currentPage.content.oCard7_sText.text,

                                    fontSize: {
                                        year: 'text-md md:text-xl lg:text-2xl pl-4 pt-4',
                                        title: 'text-2xl md:text-3xl lg:text-3xl p-4',
                                        precontent:
                                            'font-bold text-4xl md:text-4xl lg:text-6xl',
                                        content:
                                            'text-md md:text-xl lg:text-base pr-5 pb-3',
                                    },
                                    color: {
                                        year: 'text-selective_orange',
                                        pretitle: 'text-white',
                                        title: 'text-white',
                                        precontent: 'text-white',
                                        content: 'text-white',
                                        bgContent : 'bg-selective_yellow'
                                    },
                                }"
                        >

                            <template v-slot:top_outside>
                                <image-with-descriptions
                                        :options="{
                                    image: 'pages/' +
                                    currentPage.slug + '/' +
                                    currentPage.images.image6.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image6.text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            fontSize: 'text-base',
                                        },
                                    ],
                                }"
                                        class="-mb-4"/>
                            </template>


                        </TimelineTitle>

                    </div>
                </div>
            </div>
        </div>


        <timeline-carousel :options="{
            timeline: currentPage.timeline
        }"/>
    </section>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";

export default {
    name: "Page004",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.custom_padding_top {
    padding-top: 0 !important;
}
.q10__copyright {
    @apply text-nandor;
    bottom: 22%;
    position: absolute;
    left: -30%;
    transform: rotate(-90deg);
    font-size: 14px;
    @media screen and (min-width:1024px) {
        left: -18%;
        bottom: 20%;
    }
    @media screen and (min-width:1536px) {
        left: -16%;
        bottom: 18%;
    }
}
</style>
